<template>
<span>
  <slot></slot>
  <contenteditable
    tag="span"
    :noNL="true"
    :contenteditable="true"
    :noHTML="true"
    :alwaysSelectAll="false"
    v-model="teamName"
    @updated="updated"
  />
  <button ref="submitBtn" type="submit" class="hidden" name="save" value="Save">Save</button>
  </span>
</template>

<script>
export default {
  data() {
    return {
      teamName: this.$formValues['frm-teamEditForm-teamEditForm-teamName'],
    }
  },
  methods: {
    updated() {
      if (this.$refs.submitBtn) {
        this.$formValues['frm-teamEditForm-teamEditForm-teamName'] = this.teamName
        this.$nextTick(() => {
          this.$refs.submitBtn.click()
        })
      }
    }
  }
}
</script>